import { Dialog } from '@mui/material'
import CustomModelForm from './CustomModelForm'
import styles from './customModelDialog.module.scss'

/**
 * "Custom model": choose a provider, pick a model, add an API key. Preview
 * only — the key is reduced to a masked hint on save and never leaves the
 * browser. The form mounts per opening, so it always starts from what's saved.
 */
export default function CustomModelDialog({ open, saved, onClose, onSave, onRemove }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="custom-model-title"
      aria-describedby="custom-model-subtitle"
      slotProps={{ paper: { className: styles.paper } }}
    >
      <CustomModelForm saved={saved} onClose={onClose} onSave={onSave} onRemove={onRemove} />
    </Dialog>
  )
}
